
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 -1 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13 4a1 1 0 00-1 1v1.07A7 7 0 006.07 12H5a1 1 0 100 2h1.07A7 7 0 0012 19.93V21a1 1 0 102 0v-1.07A7 7 0 0019.93 14H21a1 1 0 100-2h-1.07A7 7 0 0014 6.07V5a1 1 0 00-1-1zM7.85 14A5.26 5.26 0 0012 18.15V17a1 1 0 112 0v1.15A5.26 5.26 0 0018.15 14H17a1 1 0 110-2h1.15A5.26 5.26 0 0014 7.85V9a1 1 0 11-2 0V7.85A5.26 5.26 0 007.85 12H9a1 1 0 110 2H7.85z","fill":"#F9C22E"}})])
          )
        }
      }
    